import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [empId, setEmpId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const data = {
      emp_id: empId,
      password: password,
    };

    try {
      const response = await axios.post('employee/login', data);
      const res = response.data;
      console.log(res);
      if (res.response && res.response.status == 200) {
        localStorage.setItem('token', res.data.token || response.data.data.token);
        setEmpId('');
        setPassword('');
        window.location.replace('gretings');
      } else {
        setError(res.response ? res.response.message : 'Login failed');
        setPassword('');
      }
    } catch (err) {
      console.error(err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center">
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-5">
          <div className="card card-modern p-4">
            <div className="d-flex align-items-center mb-3">
              <div style={{ width: 48, height: 48, background: 'var(--brand)', borderRadius: 8 }} className="me-3" />
              <div>
                {/* <h5 className="mb-0">SmartHR</h5> */}
                <img src='../LOGO_bg_rm.png' alt="Logo" style={{ height : 70}}/>
                <p className="text-muted">Employee sign in</p>
              </div>
            </div>

            {error && (
              <div className="alert alert-danger py-2" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={submit}>
              <div className="mb-3 form-floating">
                <input
                  id="empId"
                  type="text"
                  className="form-control"
                  placeholder="Employee ID"
                  value={empId}
                  onChange={(e) => setEmpId(e.target.value)}
                  required
                />
                <label htmlFor="empId">Employee ID</label>
              </div>

              <div className="mb-3 form-floating">
                <input
                  id="password"
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <label htmlFor="password">Password</label>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="remember" />
                  <label className="form-check-label small" htmlFor="remember">
                    Remember me
                  </label>
                </div>
                <a href="/" className="small text-muted">
                  Forgot?
                </a>
              </div>

              <button type="submit" className="btn btn-brand w-100" disabled={loading}>
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                ) : null}
                Sign in
              </button>
            </form>

            <div className="text-center small-muted mt-3">
              Need help? Contact admin.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
